/**
 * @author caijianjia
 * @date 2020/4/26 4:31 下午
 */
export const tableHead = [{
  prop: 'name',
  label: '课时名称',
  width: '180',
}, {
  prop: 'title',
  label: '课时标题',
  width: '180',
}, {
  prop: 'unit_name',
  label: '所属单元',
}, {
  prop: 'knowledge_content',
  label: '教学知识点',
}, {
  prop: 'created_at',
  label: '课时创建时间',
}, {
  prop: 'courseware_status',
  label: '课时完成状态',
},
{
  prop: 'updated_at',
  label: '课中更新时间',
},
{
  prop: 'pack_status',
  label: '课中更新状态',
},
{
  prop: 'preview',
  label: '擎想系统预览',
  filter: 'upShopBtn',
  filterOptions: {
    true: '开启',
    false: '关闭'
  }
}];

export const tableData = [];

export const filterFields = [
  [{
    attr: 'subject_id',
    name: '',
    value: '',
    type: 'Select',
    props: {
      placeholder: '请选择学科',
      rules: {
        required: false,
        message: '请选择学科',
        target: 'blur'
      },
      size: 'small',
      clearable: true
    },
    options: []
  }],
  [
    {
      attr: 'structure_id',
      "name": "",
      "value": [],
      "type": "Cascader",
      "props": {
        "placeholder": "请选择目录",
        "rules": {
          "required": false,
          "message": "请选择目录"
        },
        size: 'small',
        clearable: true
      },
      "options": []
    }
  ]
  // [{
  //   name: '',
  //   value: '',
  //   type: 'Select',
  //   props: {
  //     placeholder: '课时名称',
  //     rules: {
  //       required: false,
  //       message: '课时名称',
  //       target: 'blur'
  //     },
  //     size: 'small',
  //     clearable: true
  //   },
  //   options: []
  // }]
]



// WEBPACK FOOTER //
// ./src/views/Courseware/manage/fields.js